const CARDS = [
  {
    title: '悬疑片爱好者必看',
    desc: '反转烧脑停不下来，这十部悬疑电影让你怀疑人生。从经典密室杀局到心理惊悚，每一部都值得反复品味。',
    tag: '类型精选',
    tagColor: 'bg-accent-100 text-accent-700',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Suspenseful%20mystery%20film%20scene%20with%20dramatic%20shadows%20and%20warm%20cinematic%20lighting%20intriguing%20atmosphere%20film%20noir%20style&width=640&height=360&seq=card-1-2026&orientation=landscape',
  },
  {
    title: '治愈系电影清单',
    desc: '心情不好的时候，让这些温暖治愈的好电影陪你度过。关于爱、关于成长、关于生活里的小确幸。',
    tag: '情绪片单',
    tagColor: 'bg-primary-100 text-primary-700',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Warm%20heartwarming%20scene%20with%20soft%20golden%20sunlight%20peaceful%20natural%20landscape%20gentle%20cinematic%20tone%20emotional%20atmosphere&width=640&height=360&seq=card-2-2026&orientation=landscape',
  },
  {
    title: '科幻迷的终极收藏',
    desc: '从《2001太空漫游》到《星际穿越2》，科幻电影史上的里程碑之作全收录。硬核科幻与哲学思考的完美结合。',
    tag: '类型精选',
    tagColor: 'bg-accent-100 text-accent-700',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Futuristic%20science%20fiction%20cityscape%20with%20spaceships%20and%20neon%20lights%20epic%20cinematic%20scale%20dramatic%20sky%20composition&width=640&height=360&seq=card-3-2026&orientation=landscape',
  },
  {
    title: '周末家庭观影指南',
    desc: '适合全家一起看的合家欢电影推荐。动画、冒险、喜剧，让你和家人共度温馨的电影之夜。',
    tag: '场景推荐',
    tagColor: 'bg-secondary-200 text-secondary-800',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Happy%20family%20watching%20movie%20together%20on%20cozy%20sofa%20with%20popcorn%20warm%20living%20room%20atmosphere%20golden%20lighting&width=640&height=360&seq=card-4-2026&orientation=landscape',
  },
  {
    title: '华语文艺片珍藏',
    desc: '那些年我们错过的华语文艺佳作。从侯孝贤到贾樟柯，从王家卫到是枝裕和的华语情缘。',
    tag: '导演系列',
    tagColor: 'bg-primary-100 text-primary-700',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Artistic%20Chinese%20film%20aesthetic%20with%20traditional%20architecture%20and%20soft%20natural%20lighting%20poetic%20cinematic%20composition&width=640&height=360&seq=card-5-2026&orientation=landscape',
  },
  {
    title: '动作片硬核推荐',
    desc: '肾上腺素飙升的动作电影合集。拳拳到肉的格斗，惊心动魄的追逐，让你从头燃到尾。',
    tag: '类型精选',
    tagColor: 'bg-accent-100 text-accent-700',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Intense%20action%20movie%20scene%20with%20dynamic%20movement%20dramatic%20orange%20sky%20and%20explosive%20energy%20cinematic%20photography&width=640&height=360&seq=card-6-2026&orientation=landscape',
  },
  {
    title: '深夜独享冷门佳片',
    desc: '评分高但看的人少的宝藏电影。这些冷门佳作或许没有大制作，但每一部都值得你静下心来。',
    tag: '挖宝清单',
    tagColor: 'bg-secondary-200 text-secondary-800',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Quiet%20moody%20indie%20film%20aesthetic%20with%20rain%20on%20window%20and%20warm%20cafe%20lights%20reflective%20atmospheric%20cinematic%20tone&width=640&height=360&seq=card-7-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            影片推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑团队为你精心挑选的观影清单，发现更多好电影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {CARDS.map((card, i) => (
            <div
              key={i}
              className={`group rounded-2xl overflow-hidden bg-background-100 border border-secondary-100/60 hover:border-secondary-300/60 transition-all cursor-pointer ${
                i === 0 ? 'sm:col-span-2 sm:row-span-1' : ''
              }`}
            >
              <div className="aspect-video overflow-hidden bg-secondary-200">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4 md:p-5">
                <span
                  className={`inline-block text-xs px-2 py-0.5 rounded-full font-medium mb-2 ${card.tagColor}`}
                >
                  {card.tag}
                </span>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1.5">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}